export default "__VITE_ASSET__e97b62b2__"